import React from "react"

import ClockIcon from "../../../assets/icons/clock-icon.svg";
import classes from "./time.module.scss"

const Time = props => {
  return (
    <div className={classes.Time}>
      <ClockIcon className={classes.Icon} />
      <h3>{props.period}</h3>
      <p>{props.days}</p>
      <p className={classes.Hours}>{props.hours}</p>
    </div>
  )
}

export default Time
